export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/travel-Insurance.7d122e3a.svg","height":360,"width":462};